export default "__VITE_ASSET__C0ND2JiS__"